module.exports = __webpack_public_path__ + "img/voltaje_b.3400f125.svg";